import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';
import { setActiveCabin, removeGuestFromCabin } from 'store/actions';

import { Cabin } from 'components';

class CabinContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    return ['guests', 'selected'].reduce((prev, key) => prev || (this.props[key] !== nextProps[key]), false);
  }
  render() {
    return <Cabin {...this.props} />;
  }
}

const mapStateToProps = (state, { id, departureId }) => {
  const { number, guests, title, description, noOfBerths } = fromReservation.getCabin(state, id);
  return {
    number,
    title,
    description,
    guests,
    noOfBerths,
    remainingBeds: fromReservation.getRemainingBeds(state, id),
    selected: id === fromReservation.getActiveCabin(state, departureId),
    // cabinAllocated: fromReservation.isCabinsAllocated(state, departureId),
  };
};
const mapDispatchToProps = (dispatch, { id, selected, departureId }) => ({
  onClick: () => dispatch(setActiveCabin(selected ? '' : id, departureId)),
  onRemoveGuest: (guestId, cabinId) => dispatch(removeGuestFromCabin(guestId, cabinId)),
});

CabinContainer.propTypes = {
  id: PropTypes.string.isRequired,
  departureId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CabinContainer);



// WEBPACK FOOTER //
// ./src/containers/Cabin.js